import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { warehouseexecApi, type FulfilmentJob, type PickingWave } from '../../api/warehouseexec';

export function WavePlannerPage() {
  const [jobs, setJobs] = useState<FulfilmentJob[]>([]);
  const [wave, setWave] = useState<PickingWave | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void warehouseexecApi.listJobs().then(setJobs).catch((e) => setError(String(e)));
  }, []);

  async function releaseWave() {
    const ids = jobs.filter((j) => j.status === 'created' || j.status === 'picking').map((j) => j.id);
    if (!ids.length) return;
    try {
      const w = await warehouseexecApi.createWave({
        warehouse_id: 'wh-main', strategy: 'wave', job_ids: ids,
      });
      setWave(w);
    } catch (e) {
      setError(String(e));
    }
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/warehouse" className="text-sm text-slate-600 hover:underline">← Warehouse hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Wave planner</h1>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
      <button type="button" onClick={() => void releaseWave()} disabled={!jobs.length}
        className="mt-4 rounded-lg bg-slate-900 px-4 py-2 text-sm text-white disabled:opacity-50">
        Release wave for eligible jobs
      </button>
      {wave && (
        <div className="mt-6 rounded-xl border bg-white p-4">
          <p className="font-semibold">Wave {wave.wave_code}</p>
          <p className="text-sm text-slate-600">{wave.task_count} tasks — {wave.status}</p>
        </div>
      )}
    </div>
  );
}
